const baseTemplate = {
  customer: 'String',
  amount: 'Number',
  currency: 'String',
  source: 'String',
  description: 'String',
}

export default baseTemplate
